import React, { useState, useEffect, useContext } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FormInput from "../../components/FormInput";
import { getAdminById, UpdatePassword } from "../../middleware/backend_hepler";
import { AuthContext } from "../../Context/AuthContext";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { adminId } = useContext(AuthContext);
  const [adminData, setAdminData] = useState(null);

  const methods = useForm({
    defaultValues: {
      newPassword: "",
      confirmPassword: "",
    },
    mode: "onChange",
  });

  useEffect(() => {
    const fetchAdminData = async () => {
      if (adminId) {
        setLoading(true);
        try {
          const data = await getAdminById(adminId);
          setAdminData(data);
        } catch (error) {
          console.error("Failed to fetch admin data:", error);
          toast.error("Failed to fetch admin data.");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchAdminData();
  }, [adminId]);

  const onSubmit = async (data) => {
    setLoading(true);

    const payload = {
      password: data.password,
      confirm_password: data.confirm_password,
    };

    try {
      await UpdatePassword(adminId, payload);
      navigate("/dashboard", {
        state: { successMessage: "Password updated successfully!" },
      });
    } catch (error) {
      toast.error("Failed to update password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleViewClick = () => {
    if (adminData && adminData.photo) {
      window.open(decodeURIComponent(adminData.photo), "_blank");
    } else {
      toast.warning("No image available.");
    }
  };

  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    const initials = names.map((n) => n.charAt(0).toUpperCase()).join("");
    return initials;
  };

  return (
    <div className="container">
      <h2 className="my-4">Change Password</h2>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
          <div className="avatar-container mb-4 text-center">
            {adminData && adminData.photo ? (
              <img
                src={decodeURIComponent(adminData.photo)}
                onClick={handleViewClick}
                className="avatar-image"
                alt="Admin Avatar"
              />
            ) : (
              <div className="avatar-initials" onClick={handleViewClick}>
                {adminData && getInitials(adminData.name)}
              </div>
            )}
          </div>
          <div className="form-row">
            <FormInput
              name="password"
              label="New Password"
              registerOptions={{
                required: "Password is required",
                minLength: {
                  value: 8,
                  message: "Password should be at least 8 characters long",
                },
              }}
            />
          </div>
          <FormInput
            name="confirm_password"
            label="Confirm New Password"
            registerOptions={{
              required: "Confirm your password",
              validate: (value) =>
                value === methods.getValues("password") ||
                "Passwords do not match",
            }}
          />

          <div className="button-container mt-4 text-center">
            <Button
              variant="success"
              type="submit"
              className="custom-submit-button"
            >
              Update
            </Button>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default ChangePassword;
